
import { ProductModel } from './ProductModel';
import { GiftcardModel } from './GiftcardModel';
import { VendorStoreModel, VendorBasicModel } from './VendorModel';
import { ShippingProviderModel } from './ShippingModel';
import { TicketModel } from './TicketModel';
import { CategoryModel, ThematicModel, ZoneModel } from './CategoryModel';
import { CashlessModel, EventModel } from './EventModel';

export class MarketBaseModel {

    public constructor(init?: Partial<Pick<MarketBaseModel, keyof MarketBaseModel>>) {

        if (init) {
            // Todos los objetos relacionados
            if (init.categories && init.categories.length) {
                init.categories = init.categories.map(item => new CategoryModel(item));
            }
            if (init.stores && init.stores.length) {
                init.stores = init.stores.map(item => new VendorStoreModel(item));
            }
            if (init.vendors && init.vendors.length) {
                init.vendors = init.vendors.map(item => new VendorBasicModel(item));
            }
            if (init.shippingProviders && init.shippingProviders.length) {
                init.shippingProviders = init.shippingProviders.map(item => new ShippingProviderModel(item));
            }
            // Todos los objetos principales
            if (init.products && init.products.length) {
                init.products = init.products.map(item => new ProductModel(item));
            }
            if (init.giftcards && init.giftcards.length) {
                init.giftcards = init.giftcards.map(item => new GiftcardModel(item));
            }
            Object.assign(this, init);
        }
    }

    categories: CategoryModel[] = [];

    products: ProductModel[] = [];

    giftcards: GiftcardModel[] = [];


    stores: VendorStoreModel[] = [];

    vendors: VendorBasicModel[];

    shippingProviders: ShippingProviderModel[];
}

export class PvcMarketBaseModel {

    public constructor(init?: Partial<Pick<PvcMarketBaseModel, keyof PvcMarketBaseModel>>) {

        if (init) {
            // Todos los objetos relacionados
            if (init.categories && init.categories.length) {
                init.categories = init.categories.map(item => new CategoryModel(item));
            }
            if (init.thematics && init.thematics.length) {
                init.thematics = init.thematics.map(item => new ThematicModel(item));
            }
            if (init.zones && init.zones.length) {
                init.zones = init.zones.map(item => new ZoneModel(item));
            }
            if (init.stores && init.stores.length) {
                init.stores = init.stores.map(item => new VendorStoreModel(item));
            }
            if (init.vendors && init.vendors.length) {
                init.vendors = init.vendors.map(item => new VendorBasicModel(item));
            }
            if (init.events && init.events.length) {
                init.events = init.events.map(item => new EventModel(item));
            }
            if (init.cashless && init.cashless.length) {
                init.cashless = init.cashless.map(item => new CashlessModel(item));
            }
            if (init.tickets && init.tickets.length) {
                init.tickets = init.tickets.map(item => new TicketModel(item));
            }
            Object.assign(this, init);
        }
    }

    categories: CategoryModel[] = [];

    thematics: ThematicModel[] = [];

    zones: ZoneModel[] = [];

    
    events: EventModel[] = [];

    passes: EventModel[] = [];

    cashless: CashlessModel[] = [];

    tickets: TicketModel[] = [];


    stores: VendorStoreModel[] = [];

    vendors: VendorBasicModel[];

    shippingProviders: ShippingProviderModel[];
}
